document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    document.querySelectorAll(".compliance-email").forEach(el => {
      const classes = Array.from(el.classList);
      const user = classes.find(c => c.startsWith("user:"))?.split(":")[1];
      const domain = classes.find(c => c.startsWith("mail:"))?.split(":")[1];
      if (!user || !domain) return;
      el.setAttribute("class", '')
      const email = user + "@" + domain;
      el.setAttribute("href", "mailto:" + email);
      el.textContent = email;
    });
  }, 500);
});
